export default "__VITE_ASSET__BA38TY5q__"